import { render, staticRenderFns } from "./NejmPeriodicalList.vue?vue&type=template&id=3ab70701"
import script from "./NejmPeriodicalList.vue?vue&type=script&lang=js"
export * from "./NejmPeriodicalList.vue?vue&type=script&lang=js"
import style0 from "./NejmPeriodicalList.vue?vue&type=style&index=0&id=3ab70701&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports